/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_Empty_State_DescriptionInputs */

const fr_payments_empty_state_description = /** @type {(inputs: Payments_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez ici l'historique de vos paiements et factures dès votre premier abonnement.`)
};

/**

* @param {Payments_Empty_State_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_empty_state_description = /** @type {((inputs?: Payments_Empty_State_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_Empty_State_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_empty_state_description(inputs)
});